import React from 'react'
import { connect } from 'react-redux'
import Icon from '../Icon'
import { Link } from 'react-router-dom'
import Resx from '../Resx'
import DocumentTitle from 'react-document-title'
import { format } from '@/utils/StringUtilities'

let Breadcrumbs = ({ path }) => (
  <React.Fragment>
    <Resx render={({ localize }) => <DocumentTitle title={getDocumentTitle(localize, path)} />} />
    <ul className='breadcrumb'>
      <li><Link to='/'><Icon name='home-alt' /></Link></li>
      {path.map(step => <li key={step.id || step.text}><Breadcrumb {...step} /></li>)}
    </ul>
  </React.Fragment>
)

function getDocumentTitle (localize, path) {
  let keys = path.filter(x => typeof x.text === 'string').map(x => !x.localized ? localize(x.text) : x.text).filter(x => x).reverse()
  if (path.length === 0) {
    keys.push(localize('Common.Home'))
  }
  return format(localize('Common.AppTitle'), keys.join(' | '))
}

function Breadcrumb ({ icon, path, text, localized }) {
  return (path && path !== window.location.pathname)
    ? <Link to={path}><BreadcrumbContent value={text} localized={localized} /></Link>
    : <span><BreadcrumbContent value={text} localized={localized} /></span>
}

const BreadcrumbContent = ({ value, localized }) => (typeof value === 'string' && !localized) ? <Resx name={value} /> : value

function mapStateToProps (state, ownProps) {
  const { activePath, items } = state.menu
  return {
    path: activePath.map(step => items.find(x => x.id === step)).concat(ownProps.path || []).filter(x => x)
  }
}

Breadcrumbs = connect(mapStateToProps)(Breadcrumbs)

export {
  Breadcrumbs
}



// WEBPACK FOOTER //
// ./src/components/Layout/breadcrumbs.js